<template>
    <div>
        <q-table
            ref="table"
            :data="certificates"
            :columns="columns_certificates"
            row-key="id"
            :pagination.sync="server_pagination"
            @request="requestCertificates"
            :loading="loading"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[5,10,50,100]"
            :filter=filter_certificates
            binary-state-sort
            class="q-mt-lg"
            >

            <template slot="top" slot-scope="props" :props="props">
                <q-search v-model="filter_certificates" icon="far fa-search" :placeholder="$t('search')" :debounce="500" />

                <div class="col" />
                <q-btn color="secondary" icon="fas fa-download" :label="$t('certified_report')" @click="downloadCertificate()" />
            </template>

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                    {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <template slot="body" slot-scope="props">
                <q-tr :props="props">
                    <q-td key="user_full_name" :props="props">
                        {{ props.row.user_full_name }}
                    </q-td>

                    <q-td key="user_email" :props="props">
                        {{ props.row.user_email }}
                    </q-td>

                    <q-td key="result_date" :props="props">
                        {{ props.row.result_date }}
                    </q-td>

                    <q-td key="score" :props="props">
                        {{ props.row.score ? props.row.score.toFixed(2) : '' }}
                    </q-td>

                    <q-td key="percent" :props="props">
                        {{ props.row.percent ? `${props.row.percent.toFixed(2)}%` : '' }}
                    </q-td>

                    <q-td key="status" :props="props" auto-width>
                        <q-chip small :icon="getIconStatus(props.row.status)" :color="getColorStatus(props.row.status)" class="full-width text-center">
                            {{ $t(getTextStatus(props.row.status)) }}
                        </q-chip>
                    </q-td>

                    <q-td key="user_branches" :props="props">
                        <q-btn color="primary" text-color="white" :label="props.row.user_branches ? props.row.user_branches.length: 0" no-ripple>
                            <q-tooltip>
                                <p v-if="props.row.user_branches && props.row.user_branches.length > 0" class="tooltip q-mb-sm">
                                    {{ $t('branches') }}:
                                    <span v-for="(branch, index) in props.row.user_branches" :key="index">
                                        {{ branch }}
                                        <span v-if="(props.row.user_branches.length - 1) > index">, </span>
                                    </span>
                                </p>
                            </q-tooltip>
                        </q-btn>
                    </q-td>

                </q-tr>
            </template>
        </q-table>

        <div class="row gutter-sm justify-end q-mt-sm" v-if="status == 1">
            <div class="col-xs-12 col-sm-4">
                <q-btn color="secondary" class="full-width" :label="$t('notify_pending_users')" icon="far fa-paper-plane" @click="showNotifyUsers" />
            </div>
        </div>

        <q-modal v-model="show_notify_users" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}" no-backdrop-dismiss no-esc-dismiss>
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="show_notify_users = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('notify_pending_users') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <q-table
                        ref="table"
                        :data="users_notify"
                        :columns="columns_notify_users"
                        row-key="user_id"
                        :pagination.sync="server_pagination"
                        @request="requestNotifyUsers"
                        :loading="loading"
                        :filter="filter"
                        selection="multiple"
                        :selected.sync="users_notify_selected"
                        :no-data-label="$t('no_data_avaliable')"
                        :no-results-label="$t('no_results_found')"
                        :loading-label="$t('loading_data')"
                        :rows-per-page-label="$t('items_per_page')"
                        :rows-per-page-options="[5,10,50,100]"
                        binary-state-sort
                        class="q-mt-lg"
                        >

                        <template slot="top" slot-scope="props" :props="props">
                            <q-search v-model="filter" icon="far fa-search" :placeholder="$t('search')" :debounce="500" />

                            <div class="col" />
                        </template>

                        <q-tr slot="header" slot-scope="props" :props="props">
                            <q-th auto-width>
                                <q-checkbox v-model="props.selected" indeterminate-value="some" />
                            </q-th>

                            <q-th v-for="col in props.cols" :key="col.name" :props="props">
                                {{ $t(col.label) }}
                            </q-th>
                        </q-tr>

                        <template slot="body" slot-scope="props">
                            <q-tr :props="props">
                                 <q-td auto-width>
                                    <q-checkbox color="primary" v-model="props.selected" />
                                </q-td>

                                <q-td key="user_full_name" :props="props">
                                    {{ props.row.user_full_name }}
                                </q-td>

                                <q-td key="user_email" :props="props">
                                    {{ props.row.user_email }}
                                </q-td>

                                <q-td key="user_profile" :props="props">
                                    {{ props.row.user_profile }}
                                </q-td>

                                <q-td key="user_branches" :props="props">
                                    {{ props.row.user_branches }}
                                </q-td>
                            </q-tr>
                        </template>
                    </q-table>

                    <div class="row gutter-sm justify-end q-mt-sm" v-if="status == 1">
                        <div class="col-xs-12 col-sm-4">
                            <q-btn color="primary" class="full-width" :label="$t('notify_selected_users')" icon="far fa-check-square" @click="confirmTypeNotification('selected')" :disable="users_notify_selected.length === 0" />
                        </div>

                        <div class="col-xs-12 col-sm-4">
                            <q-btn color="secondary" class="full-width" :label="$t('notify_all_users')" icon="far fa-users" @click="confirmTypeNotification('all')" />
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>

        <q-dialog v-model="show_select_notification_message">
            <span slot="title">{{ $t(type_notification === 'all' ? 'notify_all_users' : 'notify_selected_users') }}</span>

            <span slot="body">
                {{ $t('what_kind_of_message_you_want_to_send') }}
            </span>

            <template slot="buttons" slot-scope="props" :props="props">
                <q-btn color="tertiary" :label="$t('personalized')" @click="showPersonalizeMessage()" />
                <q-btn color="positive" :label="$t('default')" @click="notifyUsers('default')" />
            </template>
        </q-dialog>

        <q-modal v-model="personalize_message" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}" no-backdrop-dismiss no-esc-dismiss>
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="personalize_message = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('personalize_message') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class="row gutter-sm">
                        <div class="col-12">
                            <q-input v-model="notification_title" :float-label="$t('title')" :error="$v.notification_title.$error" @input="$v.notification_title.$touch" />
                        </div>

                        <div class="col-12">
                            <p class="caption">{{ $t('message') }}</p>

                            <q-editor
                                v-model="notification_body"
                                :error="$v.notification_body.$error" @input="$v.notification_body.$touch"
                                :toolbar="[
                                    ['bold', 'italic', 'strike', 'underline'],
                                    ['left', 'center', 'right', 'justify'],
                                    ['link', 'upload'],
                                    [
                                        {
                                            label: null,
                                            icon: 'fas fa-font',
                                            fixedLabel: true,
                                            fixedIcon: true,
                                            list: 'no-icons',
                                            options: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'code']
                                        },
                                        {
                                            label: null,
                                            icon: 'fas fa-text-height',
                                            fixedLabel: true,
                                            fixedIcon: true,
                                            list: 'no-icons',
                                            options: ['size-1', 'size-2', 'size-3', 'size-4', 'size-5', 'size-6', 'size-7']
                                        },
                                        'removeFormat'
                                    ],
                                    ['quote', 'unordered', 'ordered']
                                ]"
                                :definitions="{
                                    bold: {label: null, icon: 'fas fa-bold'},
                                    italic: {label: null, icon: 'fas fa-italic'},
                                    strike: {label: null, icon: 'fas fa-strikethrough'},
                                    underline: {label: null, icon: 'fas fa-underline'},
                                    left: {label: null, icon: 'fas fa-align-left'},
                                    center: {label: null, icon: 'fas fa-align-center'},
                                    right: {label: null, icon: 'fas fa-align-right'},
                                    justify: {label: null, icon: 'fas fa-align-justify'},
                                    link: {label: null, icon: 'fas fa-link'},
                                    removeFormat: {label: null, icon: 'fas fa-eraser'},
                                    quote: {label: null, icon: 'fas fa-quote-right'},
                                    unordered: {label: null, icon: 'fas fa-list-ul'},
                                    ordered: {label: null, icon: 'fas fa-list-ol'}
                                }"
                                >
                            </q-editor>
                        </div>
                    </div>

                    <div class="row gutter-sm justify-end q-mt-sm">
                        <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                            <q-btn color="tertiary" class="full-width" :label="$t('cancel')" icon="far fa-chevron-left" @click="personalize_message = false" />
                        </div>

                        <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                            <q-btn color="secondary" class="full-width" :label="$t('send')" icon="far fa-paper-plane" @click="notifyUsers('personalized')" />
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>

        <q-dialog v-model="users_notified" @ok="users_notified = false">
            <span slot="title">{{ $t('notify_pending_users') }}</span>

            <span slot="body">
                {{ $t('pending_users_were_notified') }}
            </span>
        </q-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date
import { required, requiredIf } from 'vuelidate/lib/validators'

export default {
    props: ['load', 'status', 'id', 'permissions'],

    data() {
        return {
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            certificates: [],
            columns_certificates: [
                {
                    name: 'user_full_name',
                    required: true,
                    label: 'name',
                    align: 'left',
                    field: 'user_full_name',
                    sortable: true,
                },
                {
                    name: 'user_email',
                    required: true,
                    label: 'email',
                    align: 'left',
                    field: 'user_email',
                    sortable: true,
                },
                {
                    name: 'result_date',
                    required: true,
                    label: 'date',
                    align: 'left',
                    field: 'result_date',
                    sortable: true,
                },
                {
                    name: 'score',
                    required: true,
                    label: 'score',
                    align: 'left',
                    field: 'score',
                    sortable: true,
                },
                {
                    name: 'percent',
                    required: true,
                    label: 'percent',
                    align: 'left',
                    field: 'percent',
                    sortable: true,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: true,
                },
                {
                    name: 'user_branches',
                    required: true,
                    label: 'branches',
                    align: 'center',
                    field: 'user_branches',
                    sortable: false,
                }
            ],
            loading: false,
            confirm_notify_users: false,
            users_notified: false,
            show_notify_users: false,
            columns_notify_users: [
                {
                    name: 'user_full_name',
                    required: true,
                    label: 'name',
                    align: 'left',
                    field: 'user_full_name',
                    sortable: true,
                },
                {
                    name: 'user_email',
                    required: true,
                    label: 'email',
                    align: 'left',
                    field: 'user_email',
                    sortable: true,
                },
                {
                    name: 'user_profile',
                    required: true,
                    label: 'profile',
                    align: 'left',
                    field: 'user_profile',
                    sortable: true,
                }
            ],
            users_notify: [],
            users_notify_selected: [],
            type_notification: '',
            show_select_notification_message: false,
            personalize_message: false,
            notification_title: '',
            notification_body: '',
            type_message: '',
            filter: '',
            filter_certificates: ''
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            id_user_language_selected: 'common/id_user_language_selected',
            num_rows: 'datatable/num_rows'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },

    methods: {
        requestCertificates ({ pagination }) {
            this.certificates = []
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "ordering": order_by,
                "search": this.filter_certificates
            }

            this.savePagination()

            this.$axios.get(`/admin_live_classes/live_classes/${this.id}/live_class_user_results/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count

                this.certificates = response.data.results.map(e => {
                    return {
                            ...e,
                            id: e.id,
                            percent: e.percent,
                            result_date: e.result_date ? date.formatDate(e.result_date, 'DD/MM/YYYY HH:mm:ss') : "",
                            score: e.score,
                            status: e.status,
                            user_email: e.user_email,
                            user_full_name: e.user_full_name,
                            user_id: e.user_id,
                            user_id: e.user_profile,
                            user_branches: e.user_branches
                        }
                })

                this.loading = false
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
        },

        requestNotifyUsers({ pagination }) {
            this.users_notify = []
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "ordering": order_by,
                "search": this.filter
            }

            this.savePagination()

            this.$axios.get(`/admin_group_trainings/group_trainings/${this.id}/group_training_user_results/list_undone_users/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count

                this.users_notify = response.data.results.map(e => {
                    return { ...e, selected: false }
                })
            })
            .catch(e => {

                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        showNotifyUsers() {
            this.requestNotifyUsers({ pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 50,
                descending: false,
                sortBy: null
            } })
            this.show_notify_users = true
        },

        confirmTypeNotification(type) {
            this.type_notification = type
            this.show_select_notification_message = true
        },

        showPersonalizeMessage() {
            this.show_select_notification_message = false
            this.personalize_message = true
        },

        notifyUsers(type) {
            this.type_message = type

            this.$v.$touch()

            if (!this.$v.$error) {

                this.personalize_message = false
                this.show_select_notification_message = false

                let data = {}

                if (this.type_notification === 'selected') {
                    data.users_selection = this.users_notify_selected.map(e => e.user_id)
                }

                if (this.type_message === 'personalized') {
                    data.subject = this.notification_title
                    data.message = this.notification_body
                }

                this.$q.loading.show()

                this.$axios.post(`/admin_group_trainings/group_trainings/${this.id}/group_training_user_results/notificate_undone_users/`, data, this.getHeader)
                .then(response => {
                    this.users_notified = true
                })
                .catch(e => {
                    console.log(e)
                })
                .finally(() => {
                    this.show_notify_users = false
                    this.users_notify_selected = []
                    this.notification_title = ''
                    this.notification_body = ''
                    this.$v.$reset()

                    this.$q.loading.hide()
                })
            }
        },

        getTextStatus(status) {
            if (status === 1) return 'approved'
            else if (status === 2) return 'reproved'
            else return 'pending'
        },

        getColorStatus(status) {
            if (status === 1) return 'positive'
            else if (status === 2) return 'negative'
            else return 'tertiary'
        },

        getIconStatus(status) {
            if (status === 1) return 'fal fa-check'
            else if (status === 2) return 'fal fa-times'
            else return 'fal fa-clock'
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        fDate(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY HH:mm:ss'
                    break
                    default: format = 'MM-DD-YYYY HH:mm:ss'
                    break
                }

                return date.formatDate(d, format)
            }
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
        },

        loadPagination() {
            this.server_pagination.rowsPerPage = this.num_rows
        },

        downloadCertificate() {
            let message = this.$t('generating_import_file_message')
            this.$q.loading.show({
                message
            })
            this.$axios.get(`admin_live_classes/live_classes/${this.id}/live_class_user_results/generate_report/`, this.getHeader)
            .then(response => {
                this.forceFileDownload(response.data.path_url)
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
            .finally(() =>{
                this.$q.loading.hide()
            })
        },

        forceFileDownload(response){
			const link = document.createElement('a')
			link.href = response
			document.body.appendChild(link)
			link.click()
        },
    },

    watch: {
        load: function() {
            if (this.load) {
                this.requestCertificates({ pagination: this.server_pagination })
                }
            },

        num_rows: {
            handler: function(newValue) {
                this.loadPagination()
            },
            deep: true
        }
    },

    mounted() {
        this.loadPagination()
        this.requestCertificates({ pagination: this.server_pagination })
    },

    validations() {
        return {
            notification_title: {
                requiredIf: requiredIf(() => {
                    return this.type_message === 'personalized'
                })
            },

            notification_body: {
                requiredIf: requiredIf(() => {
                    return this.type_message === 'personalized'
                })
            }
        }
    }
}
</script>

<style>

</style>
